/**
 * 장부 · 생일 시트 (시안 14 L3 · L4, 결정 60 · 62). 카운터에서 「적어 주세요」 → 이모 대꾸 뒤 화면이 엽니다.
 *
 *   손잡이 → [이모 32 + 「장부 · 생일」(17/700) + 「풀이에만 써요. 나 탭에서 언제든 고치거나 지울 수 있어요.」(12) + 닫기 ×(44)]
 *   → BirthForm(양력/음력 → 생년월일 → 태어난 시간 · 「시간은 몰라요」 → 성별(선택)) → 「장부에 적기」
 *
 * - 닫기(×) · 바깥 탭 · Esc · 안드로이드 뒤로 = 「다음에요」(D1). 입력 중이던 값은 버립니다
 * - 열리면 첫 컨트롤에 포커스(README 5장)
 * - 나 탭 · 1:1 의 사주 시트(components/birth/BirthSheet)와 같은 BirthForm, 저장은 카운터 대본(POST /api/counter/messages)
 */
import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { BottomSheet } from '../../components/BottomSheet.jsx';
import { Avatar } from '../../components/Avatar.jsx';
import { BirthForm } from '../../components/birth/BirthForm.jsx';

export const LEDGER_SHEET_LABEL = '장부 · 생일';

/**
 * @param {{ open: boolean, busy: boolean, onSubmit: (birth) => void, onDecline: () => void }} props
 */
export function LedgerBirthSheet({ open, busy, onSubmit, onDecline }) {
    const bodyRef = useRef(null);

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        // 시트가 제 몸에 포커스를 둔 다음 첫 컨트롤로 옮깁니다
        const frame = requestAnimationFrame(() => {
            bodyRef.current?.querySelector('[role="radio"], button, input, select')?.focus();
        });
        return () => {
            cancelAnimationFrame(frame);
        };
    }, [open]);

    return (
        <BottomSheet open={open} onClose={onDecline} label={LEDGER_SHEET_LABEL}>
            <div className="flex items-start gap-2.5">
                <Avatar memberKey="imo" size={32} />
                <div className="flex min-w-0 flex-1 flex-col gap-0.5">
                    <h2 className="m-0 text-[17px] leading-6 font-bold">{LEDGER_SHEET_LABEL}</h2>
                    <p className="m-0 text-[12px] leading-[18px] text-text-secondary">
                        풀이에만 써요. 나 탭에서 언제든 고치거나 지울 수 있어요.
                    </p>
                </div>
                <button
                    type="button"
                    aria-label="닫기"
                    onClick={onDecline}
                    className="-mt-1.5 -mr-2.5 flex size-11 shrink-0 items-center justify-center text-text-secondary"
                >
                    <X size={20} strokeWidth={1.8} aria-hidden="true" />
                </button>
            </div>
            <div ref={bodyRef}>
                <BirthForm busy={busy} submitLabel="장부에 적기" note={false} onSubmit={onSubmit} />
            </div>
        </BottomSheet>
    );
}
